import _ from 'lodash';
import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_ACCOUNT]: state => state.account,
};

const actions = {
  async [actionTypes.DO_GET_ACCOUNT]({ commit }, payload) {
    const { host, ...params } = payload;
    const { data } = await HTTP.get(`/accounts/${host}`, { params });
    const account = data.data.accounts[0];
    const key = btoa(`${account.api_key}:${account.api_secret}`);
    const headers = _.cloneDeep(HTTP.defaults.headers);
    headers.common.Account = key;
    HTTP.defaults.headers = headers;
    commit(mutationTypes.SET_ACCOUNT, account);
    return account;
  },
};

const mutations = {
  [mutationTypes.SET_ACCOUNT](state, account) {
    state.account = account;
  },
};

export default {
  state: {
    account: {},
  },
  getters,
  actions,
  mutations,
};
